import { cn } from '../../lib/utils';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { CheckCircle, Loader2 } from 'lucide-react';

export function MonthlySummaryTable({ loading, rows }) {
  return (
    <div className="glass-card table-scroll">
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Employee</TableHead>
              <TableHead>Shift Type</TableHead>
              <TableHead>Department</TableHead>
              <TableHead>Days Present</TableHead>
              <TableHead>Late Days</TableHead>
              <TableHead>Total Deduction</TableHead>
              <TableHead>Day Shift Hours</TableHead>
              <TableHead>Night Shift Hours</TableHead>
              <TableHead>Overtime Hours</TableHead>
              <TableHead>Night OT Hours</TableHead>
              <TableHead>Exceptions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} className="text-center py-10 text-muted-foreground">
                  No attendance records found
                </TableCell>
              </TableRow>
            ) : (
              rows.map((emp) => (
                <TableRow key={emp.employee_id}>
                  <TableCell>
                    <div>
                      <p className="font-medium">{emp.employee_name}</p>
                      <p className="text-xs text-muted-foreground">{emp.employee_id}</p>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge
                      variant="outline"
                      className={cn(
                        emp.shift_type === 'Night Shift'
                          ? 'bg-indigo-500/20 text-indigo-300 border-indigo-500/30'
                          : 'bg-sky-500/20 text-sky-300 border-sky-500/30'
                      )}
                    >
                      {emp.shift_type || 'Day Shift'}
                    </Badge>
                  </TableCell>
                  <TableCell>{emp.department || '-'}</TableCell>
                  <TableCell>{emp.days_present}</TableCell>
                  <TableCell>
                    {emp.late_days > 0 ? (
                      <Badge variant="outline" className="bg-amber-500/20 text-amber-400 border-amber-500/30">
                        {emp.late_days}
                      </Badge>
                    ) : '0'}
                  </TableCell>
                  <TableCell>
                    {emp.total_late_deduction_minutes > 0 ? (
                      <span className="text-amber-400">{emp.total_late_deduction_minutes} min</span>
                    ) : '-'}
                  </TableCell>
                  <TableCell className="font-medium">
                    {(emp.total_day_shift_hours ?? 0) > 0 ? (
                      <span className="text-sky-400">{(emp.total_day_shift_hours ?? 0).toFixed(2)}h</span>
                    ) : '-'}
                  </TableCell>
                  <TableCell className="font-medium">
                    {(emp.total_night_shift_hours ?? 0) > 0 ? (
                      <span className="text-indigo-400">{(emp.total_night_shift_hours ?? 0).toFixed(2)}h</span>
                    ) : '-'}
                  </TableCell>
                  <TableCell>
                    {emp.total_overtime_hours > 0 ? (
                      <span className="text-orange-400 font-medium">{emp.total_overtime_hours.toFixed(2)}h</span>
                    ) : '-'}
                  </TableCell>
                  <TableCell>
                    {(emp.total_night_overtime_hours ?? 0) > 0 ? (
                      <span className="text-indigo-400 font-medium" title="Night hours worked as overtime (night premium)" data-testid={`monthly-night-ot-${emp.employee_id}`}>{emp.total_night_overtime_hours.toFixed(2)}h</span>
                    ) : '-'}
                  </TableCell>
                  <TableCell>
                    {emp.exception_count > 0 ? (
                      <Badge variant="destructive">{emp.exception_count}</Badge>
                    ) : (
                      <CheckCircle className="w-4 h-4 text-emerald-400" />
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
